import * as React from "react";
import BaseComponent from "components/BaseComponent";
import AreaTitle from "components/AreaTitle";
import NavigationSidebarLayout, {Navigation} from "components/NavigationSidebarLayout";
import Gravatar from "components/Gravatar/Gravatar";
import {UserResource, Permission} from "client/resources";
import {session} from "clientInstance";
import {repository} from "clientInstance";

interface UserProfileLayoutState {
    user: UserResource;
}

export class UserProfileLayout extends BaseComponent<{}, UserProfileLayoutState> {
    constructor(props: any) {
        super(props);

        this.state = ({
            user: null
        });
    }

    currentUserId(): string {
        return session && session.currentUser ? session.currentUser.Id : null;
    }

    async componentDidMount() {
        const user = this.currentUserId() ? await repository.Users.get(this.currentUserId()) : null;

        this.setState({user});
    }

    render() {
        const navLinks = [
            Navigation.navItem("My Profile", `/users/me/details`),
            Navigation.navItem("My Logins", `/users/me/logins`),
            Navigation.navItem("My API Keys", `/users/me/apiKeys`),
            Navigation.navItem("My Recent Activity", `/users/me/activity`, null, {permission: Permission.EventView, wildcard: true}),
        ];

        return (
            <div>
                <AreaTitle
                    link="/users/me"
                    title={"My Profile"}
                />
                <NavigationSidebarLayout
                    image={this.state.user ? <Gravatar user={this.state.user} size={200} /> : <div />}
                    navLinks={navLinks}
                    content={this.props.children}
                />
            </div>);
    }
}

export default UserProfileLayout;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/users/UserProfileLayout/UserProfileLayout.tsx